import React, { Component } from "react";
import { ComponentsPedidoFiltroForm } from "../components/Filtro/PedidoFiltro";
import { DataView } from "primereact/dataview";
import { Button } from "primereact/button";
import { Dropdown } from "primereact/dropdown";
import { Dialog } from "primereact/dialog";
import { Panel } from "primereact/panel";
import { PedidoPortalService } from "../service/PedidoPortal";
import { Paginator } from "primereact/paginator";
import axios from "axios";
import { ServiceLogin } from "../service/Login";
import moment from "moment/min/moment-with-locales";
import print from 'print-js';
import { InputText } from 'primereact/inputtext';
import { InputTextarea } from 'primereact/inputtextarea';
import { RadioButton } from 'primereact/radiobutton';
import { ServiceApi } from "../service/Api";
import { MedicoService } from '../service/Medico'
import { Sidebar } from 'primereact/sidebar';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { InputMask } from 'primereact/inputmask';
import { GaleriaImagens } from "../screens/Imagens/GaleriaImagens";
import { HistoricoAceiteLGPD } from "../service/HistoricoAceiteLGPD";
import { listarJob } from "../service/ServiceJob";
import './DataTableDemo.css';
import { GaleriaServices } from "../service/GaleriaServices";
import { ComponentsAppSplash } from "../components/App/Splash";

let cntPgr = 0;
let pgrBarCont = null;

const pedidoFiltro = {
    Prontuario: null,
    PacienteId: 0,
    PacienteNome: '',
    AcNumber: '',
    Prontuario: '',
    DataInicial: '',
    DataFinal: '',
    Modalidades: [],
    //Unidades:[{Id : 1,Nome : '',}, {Id : 2,Nome : '',},{Id : 3,Nome : '',}],
    Unidades: [],
    PageIndex: 0,
    PageCount: 5,
    Revisado: true,
    Sort: "DataPedido Desc",
    MedicoSolicitanteFiltro: null,
    MedicoExecutanteFiltro: null,
    ConvenioId: 0
};


const listPrazo = [
    { label: '8h', value: '8' },
    { label: '12h', value: '12' },
    { label: '24h', value: '24' },
    { label: '48h', value: '48' }
];



// Auto Heigth
const autoHeigth =
{
    height: (window.innerHeight - 100) + 'px'
};

const autoHeigthLista =
{
    textAlign: "left",
    //height: (window.innerHeight - 20) + 'px',
    overflow: "auto"
};

const getAttrs = (object, tagName) => {
    var doc = document.createElement("div");
    doc.innerHTML = object;

    const item = doc.getElementsByTagName(tagName)[0];
    return [].slice.call(item.attributes).reduce((attrs, element) => {
        attrs[element.name] = element.value;
        return attrs;
    }, {});
};

var createReactClass = require("create-react-class");

const ComponentIframe = createReactClass({
    render: function () {
        return (
            <div style={{ height: "75vh" }}>
                <iframe {...getAttrs(this.props.iframe, "iframe")} />
            </div>
        );
    }
});

const ComponentEmbed = createReactClass({
    render: function () {
        return (
            <div style={autoHeigth}>
                <embed key={this.props.id} {...getAttrs(this.props.embed, "embed")} />
            </div>
        );
    }
});

class ScreensHomeForm extends Component {
    constructor() {
        super();

        this.tipoCompartilhamento = [{ name: ' WhatsApp', key: 0 }, { name: ' Email', key: 1 }];


        this.state = {
            paciente: "",
            pedidos: [],
            layout: "list",
            selectedPedido: null,
            visible: false,
            sortKey: null,
            sortOrder: null,
            first: 0,
            rows: 5,
            Total: 0,
            panelImageVisible: false,
            panelImageJpegVisible: false,
            panelVisible: false,
            panelLaudoVisible: false,
            panelAnexoVisible: false,
            imagensVinculadas: [],
            caminhoServico: "",
            servicoImagemPortal: "",
            popupImagem: null,
            isMedico: false,
            isExecutante: false,
            emailCompartilhar: "",
            celCompartilhar: "",
            prazoValue: '8',
            pacienteId: 0,
            visibleDialog: false,
            componentImagens: "",
            visibleDialogComentario: false,
            isMobile: false,
            isFullScreen: false,
            modalConfirmaImpressao: false,
            modalImagemOutroPedido: false,
            modalAnexo: false,
            listaAnexos: null,
            Viewer: "",
            onPositionScroll: false,
            possuiJob: false,
            jobsPorPedido: {},

            // itens do pedido selecionado antes de abrir a modal de imagem em outro pedido
            pedidoComImagemVinculadaMedicoExecutante: {},
            pedidoComImagemVinculadaMedicoRevisor: {},
            pedidoComImagemVinculadaId: null,

            //Parecer médico
            listaParecer: [],
            parecerId: 0,
            parecerTexto: "",
            parecerDataCadastro: null,
            parecerPrioridade: 0,
            UsuarioId: 0,

            selectedCompartilhamento: this.tipoCompartilhamento[0],

            isAcessoCompartilhado: false,

            isLoading: true
        };
        this.galeriaServices = new GaleriaServices();
        this.pedidoservice = new PedidoPortalService();
        this.itemTemplate = this.itemTemplate.bind(this);
        this.onSortChange = this.onSortChange.bind(this);
        this.onPageChange = this.onPageChange.bind(this);
        this.pedidoSelecionado = 0;
    }

    mobilecheck() {
        var check = false;
        (function (a) {
            if (
                /(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino/i.test(
                    a
                ) ||
                /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(
                    a.substr(0, 4)
                )
            )
                check = true;
        })(navigator.userAgent || navigator.vendor || window.opera);
        return check;
    }

    _getUrl() {
        return axios
            .get("config.json")
            .then(res => res.data.servico)
            .then(url => {
                if (url[url.length - 1] === "/") return url;
                return url + "/";
            });
    }

    componentDidMount() {
        const historicoAceiteLGPD = new HistoricoAceiteLGPD();
        historicoAceiteLGPD.ChecarAceiteLGPD();

        const auth = JSON.parse(sessionStorage.getItem("auth"));

        this.setState({
            isMedico: ServiceLogin.isMedico(),
            isExecutante: ServiceLogin.isExecutante(),
            isConvenio: ServiceLogin.isConvenio(),
            UsuarioId: ServiceLogin.getUserId(),
            UsuarioNome: ServiceLogin.getUserName(),
            isAcessoCompartilhado: !!auth.TokenPortal,
            panelImageMaximizeOn: false
        });

        this._getUrl().then(url => this.setState({ caminhoServico: url }));

        // Data atual
        const hoje = moment().format("YYYY-MM-DD");
        let dataInicial = hoje;

        if (!ServiceLogin.isMedico()) {
            dataInicial = moment(`0-${moment().format("MM-DD")}`, "YYYY-MM-DD").format();

            if (ServiceLogin.isConvenio()) {
                pedidoFiltro.ConvenioId = ServiceLogin.getConvenioId();
            } else {
                pedidoFiltro.PacienteId = ServiceLogin.getUserId();
            }
        }

        pedidoFiltro.DataInicial = dataInicial;
        pedidoFiltro.DataFinal = hoje;

        if (sessionStorage.getItem("perfil") === "Solicitante") {
            pedidoFiltro.MedicoSolicitanteFiltro = { Id: ServiceLogin.getMedicoSolicitanteId() };
        }

        if (sessionStorage.getItem("perfil") === "Executante") {
            pedidoFiltro.Unidades = ServiceLogin.getUnidadesMedicoExecutante();
        }

        this.pedidoservice
            .listarPortalExamesPaged(pedidoFiltro)
            .then(data => {
                this.setState({ pedidos: data.PedidosPortal, Total: data.Count }, () => {
                    this.carregarJobsPorPedido(); // ← chama aqui depois que os pedidos estiverem prontos
                });
            });

        setTimeout(() => {
            this.DesabilitarBtnImagem(this.state.pedidos?.[0], false)
                .then(result => this.setState({ btnImageDisable: result, isLoading: false }))
                .catch(error => {
                    console.error("Erro ao desabilitar botão:", error);
                    this.setState({ btnImageDisable: true, isLoading: false });
                });
        }, 1000);

        setTimeout(() => this.alterarLayout(), 500);
    }

    async carregarJobsPorPedido() {
        const jobsPorPedido = {};

        for (const pedido of this.state.pedidos || []) {
            try {
                const res = await listarJob(pedido.AcNumber);
                jobsPorPedido[pedido.AcNumber] = res && res.length > 0;
            } catch (e) {
                console.error(`Erro ao listar job do pedido ${pedido.AcNumber}:`, e);
                jobsPorPedido[pedido.AcNumber] = false;
            }
        }

        this.setState({ jobsPorPedido });
    }


    viewFullScreen(panel) {
        let el = document.getElementById(panel);
        let elContent = el.getElementsByClassName("p-panel-content")[0];
        this.state.isFullScreen = !this.state.isFullScreen;
        if (this.state.isFullScreen === true) {
            el.setAttribute("style", "visibility: visible;position: fixed;width: 100%;top: 0;left: 0;bottom: 0;background: white;z-index: 99999;padding:0");
            //elContent.setAttribute("style", "padding:0");
            elContent.firstElementChild.setAttribute("style", "height:" + (window.innerHeight - 50) + "px");
            document.body.style.overflow = "hidden";
        } else {
            el.setAttribute("style", "visibility: visible;");
            elContent.removeAttribute("style");
            elContent.firstElementChild.setAttribute("style", "height:75vh");
            document.body.style.overflow = "auto";
        }
    }

    closeModalFullScreen(panel) {
        let el = document.getElementById(panel);
        el.removeAttribute("style");
        this.setState({ panelVisible: false, isFullScreen: false });
        document.body.style.overflow = "auto";
    }

    onSortChange(event) {
        event == "clear" ? this.setState({ sortKey: "Ordenar por" }) :
            pedidoFiltro.Sort = event.value;
        pedidoFiltro.PageIndex = 0;
        this.pedidoservice
            .listarPortalExamesPaged(pedidoFiltro)
            .then(data =>
                this.setState({
                    pedidos: data.PedidosPortal,
                    Total: data.Count,
                    panelImageVisible: false,
                    panelImageJpegVisible: false,
                    panelLaudoVisible: false,
                    panelVisible: false,
                    sortKey: event.value,
                    first: 0
                })
            );
    }


    onHideGaleria() {
        this.setState({ panelImageJpegVisible: false });
    }

    onChangeDataViewLayoutOptions(value) {
        this.setState({ layout: value });
    }

    onPageChange(event) {
        pedidoFiltro.PageIndex = event.page;
        pedidoFiltro.PageCount = event.rows;
        this.pedidoservice
            .listarPortalExamesPaged(pedidoFiltro)
            .then(data =>
                this.setState({
                    pedidos: data.PedidosPortal,
                    Total: data.Count,
                    first: event.first,
                    rows: event.rows,
                    panelImageVisible: false,
                    panelImageJpegVisible: false,
                    panelLaudoVisible: false,
                    panelVisible: false
                })
            );
    }

    panelImageJpegMaximize() {
        this.setState({ isFull: !this.state.isFull });
    }

    retDataFormatada(value) {
        return value
    }

    retLegendaPrioridade(prioridade) {
        if (prioridade === 0)
            return "Sem prioridade";
        if (prioridade === 1)
            return "Baixa";
        if (prioridade === 2)
            return "Média";
        if (prioridade === 3)
            return "Alta";
    }

    openDialogParecer(pedido) {
        this.limparFormParecer();
        let _pedidoId = pedido.Id;
        this.setState({ visibleDialogComentario: true, selectedPedido: pedido });
        let medicoService = new MedicoService();
        medicoService.GetParecerMedico(_pedidoId)
            .then(data => {
                console.log(data);
                let _listaParecer = [];

                data.Comentarios.forEach(el => {
                    let dados = {
                        DataCadastro: moment(el.DataCadastro).format("DD/MM/YYYY"),
                        Prioridade: this.retLegendaPrioridade(el.Prioridade),
                        Texto: el.Texto
                    }
                    _listaParecer.push(dados);
                });

                this.setState({
                    listaParecer: _listaParecer
                });
            })
            .catch(error => {
                console.log(error)
            }
            );
    }

    handleSalvarParecer() {
        let parecerDTO = {
            Id: 0,
            PedidoId: this.state.selectedPedido.Id,
            UsuarioId: this.state.UsuarioId,
            UsuarioNome: this.state.UsuarioNome,
            Texto: this.state.parecerTexto,
            Prioridade: this.state.parecerPrioridade,
            ParecerMedico: true
        }
        let medicoService = new MedicoService();
        medicoService.PostAdicionarParecer(parecerDTO)
            .then(response => {
                this.sucessoSalvarParecer(response);
                this.AdicionarHistoricoAcoes(33, this.state.selectedPedido.Id);
            })
            .catch(error => {
                console.log(error)
            }
            );
    }

    sucessoSalvarParecer(response) {
        alert("Parecer salvo com sucesso!");
        this.limparFormParecer();
    }

    limparFormParecer() {
        this.setState({
            parecerId: 0,
            parecerTexto: "",
            parecerPrioridade: 0,
            visibleDialogComentario: false
        });
    }

    openModalCompartilhar(pedido) {

        this.setState({
            visibleDialog: true,
            Prontuario: pedido.Prontuario,
            pacienteId: pedido.Paciente.Id,
            selectedPedido: pedido,
            prazoValue: '8',
            emailCompartilhar: "",
            celCompartilhar: ""
        })

    }

    acessoSiteAsl() {
        window.open("https://aslsofthouse.com.br/", '_new');
    }

    RetPerfil() {
        if (ServiceLogin.isConvenio()) {
            sessionStorage.setItem("perfil", "Convenio");
            return 'Convênio';
        }
        if (this.state.isExecutante) {
            sessionStorage.setItem("perfil", "Executante");
            return "Médico Executante";
        }
        if (this.state.isMedico) {
            sessionStorage.setItem("perfil", "Solicitante");
            return "Médico Solicitante";
        } else {
            return "Paciente";
        }
    }

    alterarLayout = () => {
        let perfil = document.getElementById("perfil").innerText;
        if (perfil !== "Médico Executante") {
            var head = document.getElementsByTagName('HEAD')[0];
            var link = document.createElement('link');
            link.rel = 'stylesheet';
            link.type = 'text/css';
            let layout = "layout/temaPaciente.css";
            if (perfil == "Médico Solicitante") {
                layout = "layout/temaMedico.css";
            }
            link.href = layout;
            head.appendChild(link);
        }
    }

    AdicionarHistoricoAcoes(operacao, pedidoId) {
        let usuarioId = !this.state.isMedico && !this.state.isExecutante ? null : this.state.UsuarioId;
        let url = `Api/Pedido/PostAdicionarHistorico/?operacao=${operacao}&usuarioId=${usuarioId}&pedidoId=${pedidoId}&acaoConvenio=${this.state.isConvenio}`;
        return ServiceApi.post(url);
    }

    IsNullOrEmpty(value) {
        return value === null || value === "";
    }

    DesabilitarBtnLaudo(pedido) {
        if (this.state.isMedico & ServiceLogin.getNaoPodeVisualizarPedidoSemServico())
            return !pedido.PossuiServico;

        if (pedido.Unidade.ImprimirLaudoImpressoPortal && pedido.DataImpresso === null)
            return true;

        if (pedido.Unidade.ImprimirLaudoEntreguePortal && pedido.DataEntregue === null)
            return true;

        if (pedido.ContemAnexoDiagnostico && pedido.DataRevisado)
            return false;

        if (pedido.Unidade.ImprimirLaudoEntreguePortal && pedido.DataLaudado && pedido.DataRevisado)
            return pedido.DataEntregue === null || pedido.DataEntregue === "";

        if (pedido.Unidade.ImprimirLaudoImpressoPortal && pedido.DataLaudado && pedido.DataRevisado)
            return pedido.DataImpresso === null || pedido.DataImpresso === "";

        return pedido.DataRevisado === null || pedido.DataRevisado === "";

    }

    DesabilitarBtnLaudoSemServico(pedido) {
        return ServiceLogin.getNaoPodeVisualizarPedidoSemServico() ? !pedido.PossuiServico : false;
    }

    DesabilitarBtnImagemSemServico(pedido) {
        return ServiceLogin.getNaoPodeVisualizarImagemPedidoSemServico() ? !pedido.PossuiServico : false;
    }

    DesabilitarBtnAnexo(pedido) {
        try {
            return pedido.Anexos.Count === 0;
        } catch (ex) { }
        return true;
    }

    visualizarListaAnexos(pedido) {
        this.state.listaAnexos = null;
        let _listaAnexos = [];
        pedido.Anexos.Anexos.forEach(anexo => { _listaAnexos.push(anexo); });
        this.setState({
            listaAnexos: _listaAnexos,
            modalAnexo: true,
            selectedPedido: pedido
        });
    }

    async DesabilitarBtnImagem(pedido, btnImagemDisabledSemServico) {
        if (this.state.isMedico && btnImagemDisabledSemServico) {
            return btnImagemDisabledSemServico;
        }

        try {
            const possuiJob = await listarJob(pedido.AcNumber)
                .then(res => res.length > 0)
                .catch(() => false);

            console.log('DesabilitarBtnImagem - Resultado de listarJob para', pedido.AcNumber, ':', possuiJob);

            const temStudyUid = !this.IsNullOrEmpty(pedido.StudyUid);

            if (possuiJob || temStudyUid) {
                return false; // habilitado
            }

            return true; // desabilita o botão

        } catch (error) {
            console.error('DesabilitarBtnImagem - Erro', error);
            return true;
        }
    }


    delay(ms) {
        return new Promise(resolve => setTimeout(resolve, ms));
    }

    renderListItem(pedido) {
        let dataEstudo = "";
        let btnLaudoDisabled = false;
        let btnImageDisable = false;
        let btnGaleriaDisable = false;
        let btnAnexoDisabled = false;
        let msgLaudo = "";
        let btnLaudoDisabledSemServico = false;
        let btnImagemDisabledSemServico = false;
        let titleBtnLaudoDisabledSemServico = "";
        let titleBtnImageDisabledSemServico = "";

        try {
            dataEstudo = moment(new Date(pedido.DataEstudo)).format("DD/MM/YYYY");

            btnAnexoDisabled = this.DesabilitarBtnAnexo(pedido);
            btnLaudoDisabledSemServico = this.DesabilitarBtnLaudoSemServico(pedido);
            btnLaudoDisabled = this.state.isMedico && btnLaudoDisabledSemServico
                ? btnLaudoDisabledSemServico
                : this.DesabilitarBtnLaudo(pedido);

            btnImagemDisabledSemServico = this.DesabilitarBtnImagemSemServico(pedido);
            btnImageDisable = this.state.btnImageDisable;

            msgLaudo = this.msgLaudoNaoLiberado(pedido, btnLaudoDisabledSemServico, btnImagemDisabledSemServico);

            titleBtnLaudoDisabledSemServico = this.state.isMedico && btnLaudoDisabledSemServico
                ? 'Pedido não possui serviço vinculado'
                : '';

            titleBtnImageDisabledSemServico = this.state.isMedico && btnImagemDisabledSemServico
                ? 'Pedido não possui serviço vinculado'
                : '';

            btnImageDisable = !(pedido.StudyUid && pedido.StudyUid !== "");

            const possuiJob = this.state.jobsPorPedido[pedido.AcNumber] || false;
            btnGaleriaDisable = !(possuiJob || (pedido.StudyUid && pedido.StudyUid !== ""));
        } catch (ex) {
            console.error('Erro ao renderizar item:', ex);
        }

        const NOMEBOTAO = JSON.parse(sessionStorage.getItem('config'));

        return (

            <div className="p-grid p-col-12" style={{ padding: "1em 0 0 0", borderBottom: "1px solid #e3ebf6" }}>

                <div className={this.mobilecheck() || this.state.panelVisible === false ? 'p-col-12' : 'p-col-4'}>

                    <div
                        style={{
                            display: "flex",
                            gridTemplateColumns: this.mobilecheck() ? "100px 100px 100px 100px 100px" : "auto 100px 100px 100px 100px 100px 100px 100px 100px",
                            columnGap: "5px",
                            rowGap: "5px",
                            justifyContent: "flex-end",
                            flexWrap: "wrap",
                        }}
                    >

                        <Button
                            disabled={btnLaudoDisabled}
                            type="text"
                            placeholder="Bottom"
                            tooltipOptions={{ position: "bottom" }}
                            tooltip="Visualizar Laudo" icon="pi pi-file" iconPos="right"
                            label="Visualizar Laudo"
                            className="p-button btnGreen"
                            style={{ width: "100px", height: "75px", fontSize: "11px", display: "block" }}
                            onClick={() => this.handleAbrirLaudo(pedido)}
                            title={titleBtnLaudoDisabledSemServico}
                        />

                        <Button
                            id="btnDicom"
                            disabled={btnImageDisable}
                            type="text"
                            placeholder="Bottom"
                            tooltipOptions={{ position: "bottom" }}
                            tooltip="Visualizar Exame" icon="pi pi-dicom" iconPos="right"
                            label="Visualizar Exames"
                            className={"p-button btnGreen"}
                            style={{ width: "100px", height: "75px", fontSize: "11px", display: 'block' }}
                            onClick={() => this.handleAbrirImagem(pedido)}
                            title={titleBtnImageDisabledSemServico}
                        />

                        <Button
                            disabled={btnLaudoDisabled}
                            type="text"
                            placeholder="Bottom"
                            tooltipOptions={{ position: "bottom" }}
                            tooltip="Imprimir Laudo"
                            icon="pi pi-print" iconPos="right"
                            label="Imprimir Laudo"
                            className="p-button"
                            style={{ width: "100px", height: "75px", fontSize: "11px", display: this.mobilecheck() ? 'none' : 'block' }}
                            onClick={() => this.handleImprimirLaudo(pedido)}
                            title={titleBtnLaudoDisabledSemServico}
                        />


                        <Button
                            disabled={btnGaleriaDisable}
                            type="text"
                            placeholder="Bottom"
                            tooltipOptions={{ position: "bottom" }}
                            tooltip={NOMEBOTAO ? NOMEBOTAO.NomeBotaoImprimirPortal : "Galeria de imagens"} icon="pi pi-images" iconPos="right"
                            label={NOMEBOTAO ? NOMEBOTAO.NomeBotaoImprimirPortal : "Galeria de imagens"}
                            className="p-button"
                            style={{ width: "100px", height: "75px", fontSize: "11px", display: "block" }}
                            onClick={() => { this.handleAbrirGaleriaDeImagens(pedido) }}
                            title={titleBtnImageDisabledSemServico}
                        />

                        <Button
                            disabled={btnImageDisable}
                            type="text"
                            placeholder="Bottom"
                            tooltipOptions={{ position: "bottom" }}
                            tooltip="Baixar Imagens" icon="pi pi-download" iconPos="right"
                            label="Baixar Imagens"
                            className="p-button"
                            style={{ width: "100px", height: "75px", fontSize: "11px", display: this.mobilecheck() ? "none" : "block" }}
                            onClick={() => this.handleBaixarImagem(pedido)}
                            title={titleBtnImageDisabledSemServico}
                        />

                        <div style={{ display: this.state.isExecutante ? "block" : "none" }}>

                            <Button
                                disabled={btnAnexoDisabled}
                                type="text"
                                placeholder="Bottom"
                                tooltipOptions={{ position: "bottom" }}
                                tooltip="Anexos" icon="pi pi-paperclip" iconPos="right"
                                label="Anexos"
                                className="p-button"
                                style={{ width: "100px", height: "75px", fontSize: "11px", display: "block" }}
                                onClick={() => this.visualizarListaAnexos(pedido)}
                            />

                        </div>

                        <div style={{ display: pedido.CompartilharPortal && this.state.isAcessoCompartilhado === false ? "block" : "none" }}>

                            <Button
                                disabled={btnLaudoDisabled}
                                type="text"
                                placeholder="Bottom"
                                tooltipOptions={{ position: "bottom" }}
                                tooltip="Compartilhar" icon="pi pi-share-alt" iconPos="right"
                                label="Compartilhar"
                                className="p-button"
                                style={{ width: "100px", height: "75px", fontSize: "11px", display: "block" }}
                                onClick={() => this.openModalCompartilhar(pedido)}
                                title={titleBtnLaudoDisabledSemServico}
                            />

                        </div>

                        {this.RetPerfil() === "Médico Executante" && (
                            <div style={{ display: ServiceLogin.getNaoPodeVisualizarComentarios() ? "none" : "block" }}>
                                <Button
                                    type="text"
                                    placeholder="Bottom"
                                    tooltipOptions={{ position: "bottom" }}
                                    tooltip="Parecer Médico" icon="pi pi-comment" iconPos="right"
                                    label="Parecer Médico"
                                    style={{ width: "100px", height: "75px", fontSize: "11px", display: "block" }}
                                    className="p-button"
                                    onClick={() => this.openDialogParecer(pedido)}
                                />
                            </div>
                        )}
                    </div>

                    {msgLaudo}

                    <div style={{ padding: "10px" }}>
                        <div className="car-details">
                            <div
                                style={{ display: this.state.isMedico ? "block" : "none" }}
                                className="p-col-12"
                            >
                                <b>{pedido.Paciente.Nome}</b>
                            </div>
                        </div>
                        <div className="p-col-12">
                            <b>
                                {pedido.Procedimento.Modalidade.Abreviacao} -{" "}
                                {pedido.Procedimento.Nome}
                            </b>
                        </div>
                        <div className="p-col-12" style={{ display: ServiceLogin.isConvenio() ? 'block' : 'none' }}>
                            Paciente: <b>{pedido.Paciente.Nome}</b>
                        </div>
                        <div style={{ display: pedido.Unidade.Veterinaria ? 'block' : 'none' }}>
                            <div className="p-col-12">
                                Tutor: <b>{pedido.Tutor}</b>
                            </div>
                            <div className="p-col-12">
                                Raça: <b>{pedido.Raca}</b>
                            </div>
                            <div className="p-col-12">
                                Espécie: <b>{pedido.Especie}</b>
                            </div>
                        </div>
                        <div className="p-col-12">
                            Data: <b>{dataEstudo}</b>
                        </div>
                        <div className="p-col-12">
                            Prontuário: <b>{pedido.Prontuario}</b>
                        </div>
                        <div className="p-col-12">
                            Ac. Number: <b>{pedido.AcNumber}</b>
                        </div>
                        <div className="p-col-12">
                            Médico Solicitante: <b>{pedido.MedicoSolicitante.Nome}</b>
                        </div>
                        <div className="p-col-12">
                            Médico Executante: <b>{pedido.MedicoExecutante.Nome}</b>
                        </div>
                        <div className="p-col-12">
                            Médico Revisor: <b>{pedido.MedicoRevisor.Nome}</b>
                        </div>
                        <div className="p-col-12">
                            Unidade: <b>{pedido.Unidade.Nome}</b>
                        </div>
                    </div>
                </div>

                <Panel
                    id={`panelLaudo-${pedido.Id}`}
                    className={this.state.panelVisible ? 'p-col-8' : ''}
                    style={{
                        visibility: this.mobilecheck() || this.state.panelVisible === false || this.state.selectedPedido.Id !== pedido.Id ? 'hidden' : 'visible'
                    }}

                    header={<div>
                        <div>
                            {pedido.Paciente.Nome}
                        </div>
                        <div>
                            <Button
                                icon="pi pi-window-maximize"
                                onClick={e => this.viewFullScreen(`panelLaudo-${pedido.Id}`)}
                                style={{
                                    position: "absolute",
                                    float: "right",
                                    right: this.state.isFullScreen ? "50px" : '82px',
                                    marginTop: "-25px"
                                }}
                            />
                        </div>

                        <div>
                            <Button
                                icon="pi pi-times"
                                onClick={() => this.closeModalFullScreen(`panelLaudo-${pedido.Id}`)}
                                style={{
                                    position: "absolute",
                                    float: "right",
                                    right: this.state.isFullScreen ? "7px" : "40px",
                                    marginTop: "-25px"
                                }}
                            />
                        </div>

                    </div>}
                >
                    <div id={`divLaudo-${pedido.Id}`} style={{ height: this.state.panelVisible ? '65vh' : '1px' }}></div>
                </Panel>

            </div>
        );
    }

    msgLaudoNaoLiberado(pedido, btnLaudoDisabledSemServico, btnImageDisabledSemServico) {
        if (this.state.isMedico) {
            if (btnLaudoDisabledSemServico || btnImageDisabledSemServico)
                return <div style={{ fontWeight: "bold", textAlign: "right", marginTop: "10px", marginRight: "10px", color: "red" }}>Pedido não possui serviço vinculado</div>;
        }
        const msgAlert = <div style={{ fontWeight: "bold", textAlign: "right", marginTop: "10px", marginRight: "10px", color: "red" }}>Laudo não liberado!</div>;
        if (pedido.Unidade.ImprimirLaudoEntreguePortal && pedido.DataEntregue === null)
            return msgAlert;
        if (pedido.Unidade.ImprimirLaudoImpressoPortal && pedido.DataImpresso === null)
            return msgAlert;
        if (pedido.DataRevisado === null)
            return msgAlert;
        return "";
    }

    renderGridItem(pedido) {
        let dataEstudo = "";
        let btnLaudoDisabled = false;
        let btnImageDisable = false;
        let btnGaleriaDisable = false;
        let btnAnexoDisabled = false;
        let msgLaudo = "";
        let btnLaudoDisabledSemServico = false;
        let btnImagemDisabledSemServico = false;
        let titleBtnLaudoDisabledSemServico = "";
        let titleBtnImageDisabledSemServico = "";

        try {
            dataEstudo = moment(new Date(pedido.DataEstudo)).format("DD/MM/YYYY");

            btnAnexoDisabled = this.DesabilitarBtnAnexo(pedido);
            btnLaudoDisabledSemServico = this.DesabilitarBtnLaudoSemServico(pedido);
            btnLaudoDisabled = this.state.isMedico && btnLaudoDisabledSemServico
                ? btnLaudoDisabledSemServico
                : this.DesabilitarBtnLaudo(pedido);

            btnImagemDisabledSemServico = this.DesabilitarBtnImagemSemServico(pedido);
            btnImageDisable = this.state.btnImageDisable;

            msgLaudo = this.msgLaudoNaoLiberado(pedido, btnLaudoDisabledSemServico, btnImagemDisabledSemServico);

            titleBtnLaudoDisabledSemServico = this.state.isMedico && btnLaudoDisabledSemServico
                ? 'Pedido não possui serviço vinculado'
                : '';

            titleBtnImageDisabledSemServico = this.state.isMedico && btnImagemDisabledSemServico
                ? 'Pedido não possui serviço vinculado'
                : '';

            btnImageDisable = !(pedido.StudyUid && pedido.StudyUid !== "");

            const possuiJob = this.state.jobsPorPedido[pedido.AcNumber] || false;
            btnGaleriaDisable = !(possuiJob || (pedido.StudyUid && pedido.StudyUid !== ""));
        } catch (ex) {
            console.error('Erro ao renderizar item:', ex);
        }

        const NOMEBOTAO = JSON.parse(sessionStorage.getItem('config'));

        return (
            <div style={{ padding: ".5em" }}>
                <Panel
                    header={
                        pedido.Procedimento.Modalidade.Abreviacao +
                        " - " +
                        pedido.Procedimento.Nome
                    }
                    style={{ textAlign: "center", width: "380px" }}
                >
                    <div style={{ padding: "10px" }}>
                        <div className="car-details">
                            <div
                                style={{ display: this.state.isMedico ? "block" : "none" }}
                                className="p-col-12"
                            >
                                <b>{pedido.Paciente.Nome}</b>
                            </div>
                        </div>
                        <div style={{ display: pedido.Unidade.Veterinaria ? 'block' : 'none' }}>
                            <div className="p-col-12">
                                Tutor: <b>{pedido.Tutor}</b>
                            </div>
                            <div className="p-col-12">
                                Raça: <b>{pedido.Raca}</b>
                            </div>
                            <div className="p-col-12">
                                Espécie: <b>{pedido.Especie}</b>
                            </div>
                        </div>
                        <div className="p-col-12">
                            Data: <b>{dataEstudo}</b>
                        </div>
                        <div className="p-col-12">
                            Prontuário: <b>{pedido.Prontuario}</b>
                        </div>
                        <div className="p-col-12">
                            Ac. Number: <b>{pedido.AcNumber}</b>
                        </div>
                        <div className="p-col-12">
                            Médico Solicitante: <b>{pedido.MedicoSolicitante.Nome}</b>
                        </div>
                        <div className="p-col-12">
                            Médico Executante: <b>{pedido.MedicoExecutante.Nome}</b>
                        </div>
                        <div className="p-col-12">
                            Médico Revisor: <b>{pedido.MedicoRevisor.Nome}</b>
                        </div>
                        <div className="p-col-12">
                            Unidade: <b>{pedido.Unidade.Nome}</b>
                        </div>
                    </div>

                    <hr className="ui-widget-content" style={{ borderTop: 0 }} />

                    <div
                        style={{
                            display: "grid",
                            gridTemplateColumns: this.mobilecheck() ? "auto 40px 40px 40px 40px 40px 40px" : "auto 40px 40px 40px 40px 40px 40px 40px 40px",
                            columnGap: "5px"
                        }}
                    >

                        <Button
                            disabled={btnLaudoDisabled}
                            type="text"
                            placeholder="Bottom"
                            tooltipOptions={{ position: "bottom" }}
                            tooltip="Visualizar Laudo" icon="pi pi-file"
                            className="p-button btnGreen"
                            style={{ width: "40px", height: "40px", fontSize: "20px" }}
                            onClick={() => this.handleAbrirLaudo(pedido)}
                            title={titleBtnLaudoDisabledSemServico}
                        />

                        <Button
                            disabled={btnImageDisable}
                            type="text"
                            placeholder="Bottom"
                            tooltipOptions={{ position: "bottom" }}
                            tooltip="Visualizar Exame" label=""
                            className="p-button iconDicom"
                            style={{ width: "40px", height: "40px", fontSize: "20px", display: 'block' }}
                            onClick={() => this.handleAbrirImagem(pedido)}
                            title={titleBtnImageDisabledSemServico}
                        />

                        <Button
                            disabled={btnLaudoDisabled}
                            type="text"
                            placeholder="Bottom"
                            tooltipOptions={{ position: "bottom" }}
                            tooltip="Imprimir Laudo"
                            icon="pi pi-print"
                            style={{ width: "40px", height: "40px", fontSize: "20px", display: this.mobilecheck() ? 'none' : 'block' }}
                            className="p-button"
                            onClick={() => this.handleImprimirLaudo(pedido)}
                            title={titleBtnLaudoDisabledSemServico}
                        />

                        <Button
                            disabled={btnImageDisable}
                            type="text"
                            placeholder="Bottom"
                            tooltipOptions={{ position: "bottom" }}
                            tooltip={NOMEBOTAO ? NOMEBOTAO.NomeBotaoImprimirPortal : "Imprimir Imagem"} icon="pi pi-images"
                            className="p-button"
                            style={{ width: "40px", height: "40px", fontSize: "20px" }}
                            onClick={() => this.handleAbrirGaleriaDeImagens(pedido)}
                            title={titleBtnImageDisabledSemServico}
                        />

                        <Button
                            disabled={btnImageDisable}
                            type="text"
                            placeholder="Bottom"
                            tooltipOptions={{ position: "bottom" }}
                            tooltip="Baixar Imagens" icon="pi pi-download"
                            className="p-button"
                            style={{ width: "40px", height: "40px", fontSize: "20px", display: this.mobilecheck() ? "none" : "block" }}
                            onClick={() => this.handleBaixarImagem(pedido)}
                            title={titleBtnImageDisabledSemServico}
                        />

                        <div style={{ display: this.state.isExecutante ? "block" : "none" }}>

                            <Button
                                disabled={btnLaudoDisabled}
                                type="text"
                                placeholder="Bottom"
                                tooltipOptions={{ position: "bottom" }}
                                tooltip="Anexos" icon="pi pi-paperclip"
                                className="p-button"
                                style={{ width: "40px", height: "40px", fontSize: "20px" }}
                                onClick={() => this.visualizarListaAnexos(pedido)}
                                title={titleBtnLaudoDisabledSemServico}
                            />

                        </div>

                        <div style={{ display: pedido.CompartilharPortal && this.state.isAcessoCompartilhado === false ? "block" : "none" }}>

                            <Button
                                disabled={btnLaudoDisabled}
                                type="text"
                                placeholder="Bottom"
                                tooltipOptions={{ position: "bottom" }}
                                tooltip="Compartilhar" icon="pi pi-share-alt"
                                className="p-button"
                                style={{ width: "40px", height: "40px", fontSize: "20px" }}
                                onClick={() => this.openModalCompartilhar(pedido)}
                                title={titleBtnLaudoDisabledSemServico}
                            />

                        </div>

                        <div style={{ display: ServiceLogin.getNaoPodeVisualizarComentarios() ? "none" : "block" }}>
                            <Button
                                type="text"
                                placeholder="Bottom"
                                tooltipOptions={{ position: "bottom" }}
                                tooltip="Parecer Médico" icon="pi pi-comment"
                                style={{ width: "40px", height: "40px", fontSize: "20px" }}
                                className="p-button"
                                onClick={() => this.openDialogParecer(pedido)}
                            />
                        </div>

                    </div>

                </Panel>
            </div>
        );
    }

    handleBaixarImagem(pedido) {

        this.setState({
            selectedPedido: pedido,
            panelImageVisible: false,
            panelImageJpegVisible: false,
            panelLaudoVisible: false,
            panelVisible: false
        });

        let urlImagens = "";
        if (pedido.Unidade.ServicoImagemPortal.search("studies") > 0) {
            urlImagens = pedido.Unidade.ServicoImagemPortal + "/" + pedido.StudyUid + ".zip";
        } else {
            urlImagens = pedido.Unidade.ServicoImagemPortal + "/studies/" + pedido.StudyId + "/archive";
        }

        let so = "";
        switch (navigator.platform) {
            case "MacIntel":
                so = "mac";
                break;
            case "Linux x86_64":
                so = "linux";
                break;
            default:
                so = "windows";
                break;
        }
        const tk = (Math.random(new Date().getUTCMilliseconds())).toString().replace('.', '');
        let caminho = `${this.state.caminhoServico}api/Portal/PostDownloadComVisualizador?so=${so}&urlImagens=${urlImagens}&tk=${tk}`;

        const retDominio = () => {
            try {
                const servico = this.state.caminhoServico.split('/Servico');
                return servico[0];
            } catch (ex) {
                return this.state.caminhoServico;
            }
        }
        //let dominioCliente = `${this.state.caminhoServico}`.replace("Servico", "");
        let dominioCliente = retDominio();
        dominioCliente = dominioCliente.replace("https:", "");
        dominioCliente = dominioCliente.replace("http:", "");
        dominioCliente = dominioCliente.replace(/[//"]/g, '');
        var xhr = new XMLHttpRequest();
        cntPgr = 0;
        pgrBarCont = setInterval(viewPgrContinuous, 30);
        xhr.addEventListener("progress", updateProgress, false);
        xhr.addEventListener("load", transferComplete, false);
        xhr.addEventListener("error", transferFailed, false)
        xhr.open('POST', caminho, true);
        xhr.setRequestHeader('user', `${ServiceApi._getHeaders().headers.user}`);
        xhr.setRequestHeader('Cnonce', `${ServiceApi._getHeaders().headers.Cnonce}`);
        xhr.setRequestHeader('Token', `${ServiceApi._getHeaders().headers.Token}`);
        xhr.setRequestHeader('TokenPortal', `${ServiceApi._getHeaders().headers.TokenPortal}`);
        xhr.setRequestHeader('isPacientePortal', `${ServiceApi._getHeaders().headers.isPacientePortal}`);
        xhr.setRequestHeader('isConvenioPortal', `${ServiceApi._getHeaders().headers.isConvenioPortal}`);
        xhr.responseType = 'arraybuffer';
        xhr.onload = function (e) {
            if (this.status == 200) {
                var file = new File([this.response], "MyResultApp_Download.zip", { type: "application/zip" });
                var exportUrl = URL.createObjectURL(file);
                var fileLink = document.createElement('a');
                fileLink.href = exportUrl;
                //fileLink.download = "MyResultApp_"+dominioCliente+"_"+tk+".zip";            
                fileLink.download = "MyResultApp_" + tk + ".zip";
                fileLink.click();
            }
        };
        xhr.send();

        this.AdicionarHistoricoAcoes(31, pedido.Id);

        return null;
    }

    handleAbrirImagem(pedido) {
        if (pedido.StatusImagem === 2) {
            let ultimoLaudoFiltro = {
                PacienteId: pedido.Paciente.Id,
                PacienteNome: pedido.Paciente.Nome,
                PacienteNascimento: pedido.PacienteNascimento,
                PacienteSexo: pedido.PacienteSexo,
                ModalidadeId: pedido.Modalidade.Id,
                DataCadastro: pedido.DataCadastro
            }
            this.pedidoservice.obterUltimosLaudosComStudyUid(ultimoLaudoFiltro)
                .then(data => {
                    this.setState({
                        imagensVinculadas: data.UltimosLaudos
                    });
                    this.setState({ modalImagemOutroPedido: true })
                    this.setState({ pedidoComImagemVinculadaMedicoExecutante: pedido.MedicoExecutante })
                    this.setState({ pedidoComImagemVinculadaMedicoRevisor: pedido.MedicoRevisor })
                    this.setState({ pedidoComImagemVinculadaId: pedido.Id })
                })
            return
        }
        const auth = JSON.parse(`${sessionStorage.getItem("auth")}`);

        const isSolicitante = sessionStorage.getItem("perfil") === "Solicitante";

        if (this.mobilecheck()) {
            let _viewer = pedido.Unidade.VisualizadorPortal.replace('{STUDYUID}', pedido.StudyUid);
            const parametro = _viewer.indexOf('/viewer/') > 0 ? '?' : '&';
            _viewer = _viewer.replace('{STUDYID}', pedido.StudyId);

            _viewer += `${parametro}acessoportal=1&User=${`${ServiceApi._getHeaders().headers.user}`}&Token=${`${ServiceApi._getHeaders().headers.Token}`}&Cnonce=${`${ServiceApi._getHeaders().headers.Cnonce}`}&TokenPortal=${`${ServiceApi._getHeaders().headers.TokenPortal}`}&isPacientePortal=${`${ServiceApi._getHeaders().headers.isPacientePortal}`}&isConvenioPortal=${`${ServiceApi._getHeaders().headers.isConvenioPortal}`}&isSolicitantePortal=${`${isSolicitante}`}`;

            window.open(_viewer, "imageFrame");
        } else {
            this.setState({
                selectedPedido: pedido,
                servicoImagemPortal: pedido.Unidade.ServicoImagemPortal,
                panelVisible: true,
                panelImageJpegVisible: false
            });
            let _viewer = pedido.Unidade.VisualizadorPortal.replace('{STUDYUID}', pedido.StudyUid);
            const parametro = _viewer.indexOf('/viewer/') > 0 ? '?' : '&';
            _viewer = _viewer.replace('{STUDYID}', pedido.StudyId);

            _viewer += `${parametro}acessoportal=1&User=${`${ServiceApi._getHeaders().headers.user}`}&Token=${`${ServiceApi._getHeaders().headers.Token}`}&Cnonce=${`${ServiceApi._getHeaders().headers.Cnonce}`}&TokenPortal=${`${ServiceApi._getHeaders().headers.TokenPortal}`}&isPacientePortal=${`${ServiceApi._getHeaders().headers.isPacientePortal}`}&isConvenioPortal=${`${ServiceApi._getHeaders().headers.isConvenioPortal}`}&isSolicitantePortal=${`${isSolicitante}`}`;

            const embedRemove = document.getElementsByTagName('embed');
            if (embedRemove.length > 0) {
                for (let index = 0; index < embedRemove.length; index++)
                    embedRemove[index].remove();
            }
            const embed = document.createElement('embed');
            embed.src = _viewer;
            embed.width = '100%';
            embed.height = '100%';
            document.getElementById(`divLaudo-${pedido.Id}`).append(embed);
            this.onScrollIntoView(`divLaudo-${pedido.Id}`);
            this.setState({ modalImagemOutroPedido: false })
        }
        this.AdicionarHistoricoAcoes(30, pedido.Id);
        return null;
    }

    handleImprimirLaudo(pedido) {

        if (this.mobilecheck())
            return alert("Impressão de laudo somente por computador.");

        this.pedidoSelecionado = pedido;

        if (this.pedidoSelecionado.ContemAnexoDiagnostico && this.state.isExecutante)
            return this.setState({ modalConfirmaImpressao: true });

        //if(this.pedidoSelecionado.DataRevisado === null || this.pedidoSelecionado.ContemAnexoDiagnostico)
        //return this.confirmaImprimirLaudo(true);

        return this.confirmaImprimirLaudo(true);
    }

    confirmaImprimirLaudo(anexoDiagnostico) {
        if (this.pedidoSelecionado) {
            let caminho = `${this.state.caminhoServico}api/Portal/GetResultadoPdf?id=${this.pedidoSelecionado.IdExterno}&anexoDiagnostico=${anexoDiagnostico}`;
            var xhr = new XMLHttpRequest();

            xhr.open('GET', caminho, true);

            xhr.setRequestHeader('user', `${ServiceApi._getHeaders().headers.user}`);
            xhr.setRequestHeader('Cnonce', `${ServiceApi._getHeaders().headers.Cnonce}`);
            xhr.setRequestHeader('Token', `${ServiceApi._getHeaders().headers.Token}`);
            xhr.setRequestHeader('TokenPortal', `${ServiceApi._getHeaders().headers.TokenPortal}`);
            xhr.setRequestHeader('isPacientePortal', `${ServiceApi._getHeaders().headers.isPacientePortal}`);
            xhr.setRequestHeader('isConvenioPortal', `${ServiceApi._getHeaders().headers.isConvenioPortal}`);

            xhr.responseType = 'arraybuffer';
            xhr.onload = function (e) {
                if (this.status == 200) {
                    var blob = new Blob([this.response], { type: "application/pdf" });
                    var pdfUrl = URL.createObjectURL(blob);
                    print(pdfUrl);
                }
            };
            xhr.send();
            this.AdicionarHistoricoAcoes(38, this.pedidoSelecionado.Id);
        }
        return null;
    }

    handleAbrirLaudo(pedido) {
        if (this.mobilecheck()) {
            let _anexoDiagnostico = pedido.DataRevisado === null || pedido.ContemAnexoDiagnostico;
            let caminho = `${this.state.caminhoServico}api/Portal/GetResultadoPdf?id=${pedido.IdExterno}&anexoDiagnostico=${_anexoDiagnostico}`;
            //window.open(caminho, "LaudoFrame"); //Abrir em nova aba            
            var xhr = new XMLHttpRequest();
            cntPgr = 0;
            pgrBarCont = setInterval(viewPgrContinuous, 30);
            xhr.addEventListener("progress", updateProgress, false);
            xhr.addEventListener("load", transferComplete, false);
            xhr.addEventListener("error", transferFailed, false)

            xhr.open('Get', caminho, true);

            xhr.setRequestHeader('user', `${ServiceApi._getHeaders().headers.user}`);
            xhr.setRequestHeader('Cnonce', `${ServiceApi._getHeaders().headers.Cnonce}`);
            xhr.setRequestHeader('Token', `${ServiceApi._getHeaders().headers.Token}`);
            xhr.setRequestHeader('TokenPortal', `${ServiceApi._getHeaders().headers.TokenPortal}`);
            xhr.setRequestHeader('isPacientePortal', `${ServiceApi._getHeaders().headers.isPacientePortal}`);
            xhr.setRequestHeader('isConvenioPortal', `${ServiceApi._getHeaders().headers.isConvenioPortal}`);

            xhr.responseType = 'arraybuffer';
            xhr.onload = function (e) {
                if (this.status == 200) {
                    var file = new File([this.response], `Laudo_${pedido.IdExterno}.pdf`, { type: "application/pdf" });
                    var exportUrl = URL.createObjectURL(file);
                    var fileLink = document.createElement('a');
                    fileLink.href = exportUrl;
                    fileLink.download = `Laudo_${pedido.Id}.pdf`;
                    fileLink.click();
                }
            };
            xhr.send();

        } else {
            this.setState({
                selectedPedido: pedido,
                panelVisible: true,
                panelAnexoVisible: false,
            });

            let _anexoDiagnostico = pedido.DataRevisado === null || pedido.ContemAnexoDiagnostico;

            const caminho = `${this.state.caminhoServico}api/Portal/GetResultadoPdf?id=${pedido.IdExterno}&anexoDiagnostico=${_anexoDiagnostico}`;

            const embedRemove = document.getElementsByTagName('embed');

            if (embedRemove.length > 0) {
                for (let index = 0; index < embedRemove.length; index++)
                    embedRemove[index].remove();
            }

            const headers = new Headers();
            headers.append('user', `${ServiceApi._getHeaders().headers.user}`);
            headers.append('Cnonce', `${ServiceApi._getHeaders().headers.Cnonce}`);
            headers.append('Token', `${ServiceApi._getHeaders().headers.Token}`);
            headers.append('TokenPortal', `${ServiceApi._getHeaders().headers.TokenPortal}`);
            headers.append('isPacientePortal', `${ServiceApi._getHeaders().headers.isPacientePortal}`);
            headers.append('isConvenioPortal', `${ServiceApi._getHeaders().headers.isConvenioPortal}`);

            const requestOptions = {
                method: 'GET',
                headers: headers,
            };

            const embed = document.createElement('embed');

            fetch(caminho, requestOptions)
                .then(response => {
                    return response.blob();
                })
                .then(blob => {
                    embed.src = URL.createObjectURL(blob);
                    document.getElementById(`divLaudo-${pedido.Id}`).append(embed);
                }).catch(error => {
                    console.error('Erro na requisição:', error);
                });

            embed.width = '100%';
            embed.height = '100%';

            this.setDialogContentSize();

            this.onScrollIntoView(`divLaudo-${pedido.Id}`);
        }
        this.AdicionarHistoricoAcoes(28, pedido.Id);
        return null;
    }

    onScrollIntoView(el) {
        setTimeout(() => {
            document.getElementById(el).scrollIntoView();
            const _scrollTop = document.scrollingElement.scrollTop.toFixed() - 200;
            window.scroll(0, _scrollTop);
        }, 200);
    }

    setDialogContentSize = () => {
        try {
            const pDialogContent = document.getElementsByClassName('p-panel-content')[0];
            const embed = document.getElementsByTagName('embed')[0];
            pDialogContent.style.padding = '0';
            pDialogContent.style.overflow = 'hidden';
            embed.style.height = `${pDialogContent.clientHeight}px`;
        } catch (ex) { }
    }

    async handleAbrirGaleriaDeImagens(pedido) {
        try {
            const possuiJob = await listarJob(pedido.AcNumber);
            // const possuiJob = false;

            if (possuiJob.length > 0) {
                sessionStorage.setItem('pedido', JSON.stringify(pedido));
                this.props.history.push({
                    pathname: '/Jobs',
                });
            } else {
                this.setState({
                    selectedPedido: pedido,
                    servicoImagemPortal: pedido.Unidade.ServicoImagemPortal,
                    panelImageJpegVisible: true
                });
                this.AdicionarHistoricoAcoes(29, pedido.Id);
            }
        } catch (error) {
            console.error("Erro ao listar jobs:", error);
            alert("Não foi possível conectar ao servidor, tente novamente.");
            this.props.location.href = '#/portal';
        }
    }


    handleCompartilharLinkPortal() {
        var tipoCompartilhamento = this.state.selectedCompartilhamento.key;
        var urlAcesso = `${window.location.origin}${window.location.pathname}`;
        urlAcesso = urlAcesso.replace('https://', '');
        urlAcesso = urlAcesso.replace('http://', '');
        var cel = this.state.celCompartilhar;
        var email = this.state.emailCompartilhar;
        var prazo = this.state.prazoValue;
        var cnonce = (Math.random(new Date().getUTCMilliseconds())).toString().replace('.', '');
        let url = `api/Portal/PostCompartilharLinkPortal/?prontuario=${this.state.Prontuario}&pacienteid=${this.state.pacienteId}&url=${urlAcesso}&email=${email}&prazo=${prazo}&cnonce=${cnonce}&tipoCompartilhamento=${tipoCompartilhamento}&unidadeId=${this.state.selectedPedido.Unidade.Id}&pedidoId=${this.state.selectedPedido.Id}`;
        this.AdicionarHistoricoAcoes(32, this.state.selectedPedido.Id);
        return ServiceApi.post(url)
            .then(res => {
                if (tipoCompartilhamento === 0) {

                    res = res.replace('http:', 'https:');
                    cel = cel.replace('-', '');
                    cel = cel.replace('(', '');
                    cel = cel.replace(')', '');

                    if (cel) {
                        // var msgFormat = "*Prezado(a)*,%0A";
                        // msgFormat += "Foi compartilhado um link de acesso do portal MyResult:%0A%0A";
                        // msgFormat += "*Link:*%0A" + res + "%0A%0A";
                        // msgFormat += "O link de acesso ao portal expira em: *" + prazo + "h*";
                        window.encodeURIComponent(res);

                        cel = `+55${cel}`;
                        window.encodeURIComponent(cel);
                        //Gerar link para WhatsApp (compatibilidade com iPhone)
                        const linkWhatsapp = document.createElement("a");
                        linkWhatsapp.href = `https://${this.mobilecheck() ? 'api' : 'web'}.whatsapp.com/send?phone=${cel}&text=${res}`;
                        linkWhatsapp.target = `${this.mobilecheck() ? '' : "_new"}`;
                        document.body.appendChild(linkWhatsapp);
                        linkWhatsapp.click();
                        linkWhatsapp.remove();
                    } else {
                        alert("Preencha o número do celular que deseja compartilhar o link do portal.");
                    }

                } else {
                    alert(res);
                }

                this.setState({
                    visibleDialog: false,
                    prazoValue: 0,
                    emailCompartilhar: "",
                    celCompartilhar: ""
                });

            });
    }

    itemTemplate(pedido, layout) {

        if (!pedido) {
            return;
        }
        if (layout === "list")
            return this.renderListItem(pedido);
        else if (layout === "grid") return this.renderGridItem(pedido);
    }

    renderPedidoDialogContent() {
        if (this.state.selectedPedido) {
            return (
                <div
                    className="p-grid"
                    style={{ fontSize: "16px", textAlign: "center", padding: "20px" }}
                >
                    <div className="p-col-12" style={{ textAlign: "center" }}>
                        {/* <img src={'showcase/resources/demo/images/car/${this.state.selectedCar.brand}.png'} alt={this.state.selectedCar.brand} /> */}
                    </div>
                    <div className="p-col-4">Paciente: </div>
                    <div className="p-col-8">
                        {this.state.selectedPedido.Paciente.Nome}
                    </div>

                    <div className="p-col-4">Procedimento: </div>
                    <div className="p-col-8">
                        {this.state.selectedPedido.Procedimento.Nome}
                    </div>

                    <div className="p-col-4">Medico Executante: </div>
                    <div className="p-col-8">
                        {this.state.selectedPedido.MedicoExecutante.Nome}
                    </div>

                    <div className="p-col-4">Medico Revisor: </div>
                    <div className="p-col-8">
                        {this.state.selectedPedido.MedicoRevisor.Nome}
                    </div>

                    <div className="p-col-4">Modalidade: </div>
                    <div className="p-col-8">
                        {this.state.selectedPedido.Modalidade.Nome}
                    </div>
                </div>
            );
        } else {
            return null;
        }
    }

    onExecuteFiltro(filtro) {

        pedidoFiltro.Modalidades = filtro.modalidades;
        pedidoFiltro.PacienteNome = filtro.paciente;
        pedidoFiltro.AcNumber = filtro.acNumber;
        pedidoFiltro.Prontuario = filtro.prontuario;
        pedidoFiltro.DataInicial = filtro.dataInicial;
        pedidoFiltro.DataFinal = filtro.dataFinal;
        pedidoFiltro.PageIndex = 0;
        pedidoFiltro.PageCount = this.state.rows;

        this.pedidoservice
            .listarPortalExamesPaged(pedidoFiltro)
            .then(data => {
                this.setState({
                    pedidos: data.PedidosPortal,
                    Total: data.Count,
                    panelImageVisible: false,
                    panelLaudoVisible: false
                });
                if (data.Count > 0) {
                    this.positionScroll();
                }
                this.setState({ onPositionScroll: true })
            })
    }

    positionScroll() {
        window.scroll(0, 0);
        if (this.state.onPositionScroll) {
            try {
                const topPos = document.getElementById('gridListaPedidos').offsetTop - 50;
                window.scroll(0, topPos)
            } catch (error) { }
        }
    }

    renderHeaderTopInfo() {
        return (
            <div className="p-grid p-col-12">
                <div className="p-col-6">Bem vindo {this.state.UsuarioNome}!</div>
                <div className="p-col-6" style={{ textAlign: "right" }}>Perfil: <span id="perfil">{this.RetPerfil()}</span></div>
            </div>
        )
    }

    renderHeaderLista() {

        if (this.state.isMedico || ServiceLogin.isConvenio()) {

            return (
                <div className="filtroForm">
                    <ComponentsPedidoFiltroForm
                        mobilecheck={this.mobilecheck}
                        onSortChange={this.onSortChange}
                        sortKey={this.state.sortKey}
                        onChangeDataViewLayoutOptions={value => this.onChangeDataViewLayoutOptions(value)}
                        layout={this.state.layout}
                        filtro={this.pedidoFiltro}
                        onExecute={this.onExecuteFiltro.bind(this)}
                        style={{ width: "100%" }}
                    />
                </div>
            );
        }
    }

    renderHeaderAnexoDiagnostico() {
        return (
            <div>
                <div>
                    <span>Anexo Diagnóstico</span>
                </div>
                <Button
                    icon="pi pi-times"
                    onClick={e => this.setState({ panelAnexoVisible: false })}
                    style={{
                        position: "absolute",
                        float: "right",
                        right: "22px",
                        marginTop: "-25px"
                    }}
                />
            </div>
        );
    }

    renderPainelAnexoDiagnostico() {

        if (this.state.panelAnexoVisible) {

            const caminho = `${this.state.caminhoServico}api/Anexo/GetAnexoPortal/${this.state.selectedPedido.Id}`;
            const embed = `<embed src="${caminho}" width="100%" height="100%" />`;
            return (
                <div className={this.state.panelAnexoVisible ? "p-col-7" : ""}>
                    <Panel
                        header={this.renderHeaderAnexoDiagnostico()}
                        style={
                            this.state.panelAnexoVisible
                                ? { visibility: "visible" }
                                : { visibility: "hidden" }
                        }
                    >
                        <div>
                            <ComponentEmbed
                                embed={embed}
                                id={this.state.selectedPedido.IdExterno}
                            />
                        </div>
                    </Panel>
                </div>
            );
        } else return null;
    }

    onHide(name) {
        this.setState({
            [`${name}`]: false
        });
    }

    renderFooter(name) {
        return (
            <div>
                <Button label="Sim" icon="pi pi-check" onClick={() => { this.confirmaImprimirLaudo(true); this.onHide(name); }} autoFocus />
                <Button label="Não" icon="pi pi-times" onClick={() => { this.confirmaImprimirLaudo(false); this.onHide(name); }} className="p-button-text" />
            </div>
        );
    }

    renderFooterCancelar(name) {
        return (
            <div>
                <Button label="Cancelar" icon="pi pi-times" onClick={() => { this.onHide(name); }} className="p-button-text" />
            </div>
        );
    }

    dataEstudoImagemVinculada(rowData) {
        const date = new Date(rowData.DataEstudo);
        const options = { year: 'numeric', month: 'numeric', day: 'numeric', hour: 'numeric', minute: 'numeric', second: 'numeric' };
        const formattedDate = date.toLocaleString([], options);

        return (
            <>
                <span className="p-column-title">Data</span>
                {formattedDate}
            </>
        )
    }

    idLaudoImagemVinculada(rowData) {
        return (
            <>
                <span className="p-column-title">ID</span>
                {rowData.Id}
            </>
        )
    }

    procedimentoImagemVinculada(rowData) {
        return (
            <>
                <span className="p-column-title">Procedimento</span>
                {rowData.ProcedimentoNome}
            </>
        )
    }

    modalidadeImagemVinculada(rowData) {
        return (
            <>
                <span className="p-column-title">Modalidade</span>
                {rowData.ModalidadeNome}
            </>
        )
    }

    botaoVisualizarImagemVinculada = (rowData) => {
        const abreImagemDoPedidoSelecionado = () => {
            let _viewer = rowData.VisualizadorPortal.replace('{STUDYUID}', rowData.StudyUid);
            _viewer = _viewer.replace('{STUDYID}', rowData.StudyId);

            const embedRemove = document.getElementsByTagName('embed');

            if (embedRemove.length > 0) {
                for (let index = 0; index < embedRemove.length; index++)
                    embedRemove[index].remove();
            }

            let pedido = rowData;
            pedido.Modalidade = { Nome: rowData.ModalidadeNome };
            pedido.Procedimento = { Nome: rowData.ProcedimentoNome };
            pedido.MedicoExecutante = this.state.pedidoComImagemVinculadaMedicoExecutante;
            pedido.MedicoRevisor = this.state.pedidoComImagemVinculadaMedicoRevisor;
            pedido.Id = this.state.pedidoComImagemVinculadaId;
            this.handleAbrirImagem(pedido);
        };

        return (
            <div style={{ display: 'flex', justifyContent: 'center' }}>
                <Button label={"Visualizar"} icon="pi pi-eye" onClick={abreImagemDoPedidoSelecionado}></Button>
            </div>
        );
    };

    renderHeaderAnexoDiagnostico() {
        return (<div> <i className="pi pi-paperclip"></i> Anexos </div>)
    }
    renderFooterAnexo(name) {
        return (
            <div>
                <Button label="Fechar" icon="pi pi-times" onClick={() => this.onHide(name)} className="p-button-text" />
            </div>
        );
    }

    nomeArquivoAnexoMob(rowData) {
        return <div style={{ display: "flex", alignItems: "center" }}>
            <img src={require('./../images/pdf.png')} style={{ width: "24px", height: "24px", marginRight: "5px" }} />
            <span style={{ marginTop: "7px" }}>{rowData.Nome.slice(0, 15) + (rowData.Nome.length > 15 ? "..." : "")}</span>
            <div className={`anexo status-${rowData.TipoAnexo}`}
                style={{ padding: '5px', textAlign: 'center', marginLeft: '5px', fontSize: '10px' }}
            >{rowData.TipoAnexo === 0 ? 'Normal' : 'Diagnóstico'}</div>
        </div>
    }

    nomeArquivoAnexo(rowData) {
        return <div style={{ display: "flex", alignItems: "center" }}>
            <img src={require('./../images/pdf.png')} style={{ width: "24px", height: "24px", marginRight: "5px" }} />
            <span style={{ marginTop: "7px" }}>{rowData.Nome}</span>
        </div>
    }

    statusTipoAnexo(rowData) {
        let _tipoAnexo = "";
        switch (rowData.TipoAnexo) {
            case 0:
                _tipoAnexo = "Normal";
                break;
            case 1:
                _tipoAnexo = "Diagnóstico";
                break;
            case 2:
                _tipoAnexo = "Anamnese";
                break;
            case 3:
                _tipoAnexo = "Ped. Médico";
                break;
        }
        return <div style={{ textAlign: "center" }}>
            <div className={`anexo status-${rowData.TipoAnexo}`}>{_tipoAnexo}</div>
        </div>;
    }

    visualizarAnexo(rowData) {
        window.open(`${this.state.caminhoServico}api/Anexo/GetAnexo/${rowData.Id}`, "AnexoFrame");
        let operacao = rowData.TipoAnexo === 1 ? 36 : 34;
        this.AdicionarHistoricoAcoes(operacao, this.state.selectedPedido.Id);
    }

    downloadAnexo(rowData) {
        const downloadUrl = `${this.state.caminhoServico}api/Anexo/GetAnexo/${rowData.Id}`;
        var postData = new FormData();
        var xhr = new XMLHttpRequest();
        xhr.open('GET', downloadUrl, true);
        xhr.responseType = 'blob';
        xhr.onload = function (e) {
            var blob = xhr.response;
            var fileName = `${rowData.Nome}`;
            var tempEl = document.createElement("a");
            document.body.appendChild(tempEl);
            tempEl.style = "display: none";
            let url = window.URL.createObjectURL(blob);
            tempEl.href = url;
            tempEl.download = fileName;
            tempEl.click();
            window.URL.revokeObjectURL(url);
        }.bind(this)
        xhr.send(postData);

        //Adicionar histórico
        let operacao = rowData.TipoAnexo === 1 ? 37 : 35;
        this.AdicionarHistoricoAcoes(operacao, this.state.selectedPedido.Id);
    }

    btnAnexoAcoes(rowData) {
        return <div style={{ textAlign: "center" }}>
            <Button label="" tooltip="Visualizar" onClick={() => this.visualizarAnexo(rowData)} icon="pi pi-eye" className="p-button p-button-secondary" style={{ marginRight: "5px" }} />
            <Button label="" tooltip="Download" onClick={() => this.downloadAnexo(rowData)} icon="pi pi-cloud-download" className="p-button p-button-secondary" />
        </div>;
    }

    btnAnexoAcoesMob(rowData) {
        return <div style={{ textAlign: "center", display: 'grid', gridTemplateRows: 'auto auto', rowGap: '5px' }}>
            <Button label="" tooltip="Visualizar" onClick={() => this.visualizarAnexo(rowData)} icon="pi pi-eye" className="p-button p-button-secondary" style={{ marginRight: "5px" }} />
            <Button label="" tooltip="Download" onClick={() => this.downloadAnexo(rowData)} icon="pi pi-cloud-download" className="p-button p-button-secondary" />
        </div>;
    }

    render() {
        const headerLista = this.renderHeaderLista();

        const prioridadeSelectItems = [
            { label: 'Sem prioridade', value: 0 },
            { label: 'Baixa', value: 1 },
            { label: 'Média', value: 2 },
            { label: 'Alta', value: 3 }
        ];


        return (

            <div className="layout-main" style={{ height: "85vh" }}>


                <Dialog header="Confirmar Impressão" position="top" visible={this.state.modalConfirmaImpressao} style={{ width: '30vw' }} footer={this.renderFooter('modalConfirmaImpressao')} onHide={() => this.onHide('modalConfirmaImpressao')}>
                    <p>Esse exame possui Anexo Diagnóstico. Deseja imprimir junto com o laudo?</p>
                </Dialog>

                <Dialog header="Aviso"
                    position="top" visible={this.state.modalImagemOutroPedido} style={{ width: this.mobilecheck() ? '90vw' : '70vw' }} footer={this.renderFooterCancelar('modalImagemOutroPedido')} onHide={() => this.onHide('modalImagemOutroPedido')}>
                    <p style={{ fontSize: '16px', marginTop: '.5rem', fontWeight: 'bold' }}>O pedido selecionado não possui imagem vinculada. Porém, suas imagens podem estar vinculadas em um pedido do mesmo paciente e da mesma modalidade.</p>
                    <div className="datatable-responsive-demo">
                        <div className="card">
                            <DataTable value={this.state.imagensVinculadas} className="p-datatable-gridlines p-datatable-responsive-demo">
                                <Column field="Visualizar" header=" " body={this.botaoVisualizarImagemVinculada.bind(this)} />
                                <Column field="Laudo" header="Laudo" body={this.idLaudoImagemVinculada} />
                                <Column field="Data do Estudo" header="Data do Estudo" body={this.dataEstudoImagemVinculada} />
                                <Column field="Procedimento" header="Procedimento" body={this.procedimentoImagemVinculada} />
                                <Column field="Modalidade" header="Modalidade" body={this.modalidadeImagemVinculada} />
                            </DataTable>
                        </div>
                    </div>
                </Dialog>

                <Dialog header={this.renderHeaderAnexoDiagnostico()} visible={this.state.modalAnexo}
                    style={{ width: this.mobilecheck() ? '100%' : '50vw' }}
                    footer={this.renderFooterAnexo('modalAnexo')} onHide={() => this.onHide('modalAnexo')}>

                    <div className="card" style={{ display: this.mobilecheck() ? 'none' : 'block' }} >
                        <DataTable value={this.state.listaAnexos} className="p-datatable-gridlines">
                            <Column field="Nome" header="Nome" body={this.nomeArquivoAnexo}></Column>
                            <Column field="TipoAnexo" header="Tipo" body={this.statusTipoAnexo} headerStyle={{ width: '9em' }} ></Column>
                            <Column field="" header="Ações" headerStyle={{ width: '9em' }} body={(e) => this.btnAnexoAcoes(e)}></Column>
                        </DataTable>
                    </div>

                    <div style={{ display: this.mobilecheck() ? 'block' : 'none' }} >
                        <DataTable value={this.state.listaAnexos} className="p-datatable-gridlines">
                            <Column field="Nome" header="Nome" body={this.nomeArquivoAnexoMob}></Column>
                            <Column style={{ width: '70px' }} field="" header="Ações" body={(e) => this.btnAnexoAcoesMob(e)}></Column>
                        </DataTable>
                    </div>

                </Dialog>


                {this.renderHeaderTopInfo()}

                <img onClick={e => { { this.acessoSiteAsl(); } }} src={require('./../images/tzion.png')} className="logoTzionTopHome" />



                <div className="p-grid p-fluid">
                    <div className="p-col-12 p-lg-12">

                        <div
                            className="content-section introduction"
                            style={{ display: this.state.isMedico ? "none" : "block" }}
                        >
                            <div className="feature-intro" style={{ display: ServiceLogin.isConvenio() ? 'none' : 'block' }}>
                                <h1>
                                    {this.state.pedidos.length > 0 ? this.state.pedidos[0].Paciente.Nome : "Carregando"}
                                </h1>
                                <p>Sua lista de exames realizados</p>
                            </div>

                        </div>

                        {headerLista}

                        <div id="gridListaPedidos" className="content-section implementation">
                            <div className="p-grid">
                                <div
                                    className={
                                        this.state.panelImageJpegVisible || this.state.panelAnexoVisible
                                            ? "p-col-5"
                                            : "p-col-12"
                                    }
                                    style={autoHeigthLista}
                                >
                                    <DataView
                                        value={this.state.pedidos}
                                        layout={this.state.layout}
                                        // header={headerLista}
                                        itemTemplate={this.itemTemplate}
                                        paginatorPosition={"none"}
                                        paginator={false}
                                        rows={10}
                                        sortOrder={this.state.sortOrder}
                                        sortField={this.state.sortField}
                                    />

                                    <Paginator
                                        first={this.state.first}
                                        rows={this.state.rows}
                                        totalRecords={this.state.Total}
                                        rowsPerPageOptions={[10, 20, 30]}
                                        onPageChange={this.onPageChange}
                                    />
                                </div>

                                {this.renderPainelAnexoDiagnostico(0)}

                            </div>

                            <Dialog
                                header="Detalhes do Pedido"
                                visible={this.state.visible}
                                width="225px"
                                modal={true}
                                onHide={() => this.setState({ visible: false })}
                            >
                                {this.renderPedidoDialogContent()}
                            </Dialog>
                        </div>
                    </div>

                </div>

                <Sidebar
                    header="Galeria de Imagens"
                    blockScroll={true}
                    fullScreen={true}
                    visible={this.state.panelImageJpegVisible}
                    modal={false}
                    //onHide={() => this.setState({panelImageJpegVisible: false})} 
                    style={{ zIndex: "999", border: "none", backgroundColor: "#000", padding: "0" }}
                    showCloseIcon={false}
                >

                    <GaleriaImagens
                        selectedPedido={this.state.selectedPedido}
                        servicoImagem={this.state.servicoImagemPortal}
                        panelImageJpegMaximize={(e) => this.panelImageJpegMaximize()}
                        handleFecharImagemJpg={(e) => this.handleFecharImagemJpg()}
                        onHideGaleria={() => this.onHideGaleria()}
                        mobilecheck={() => this.mobilecheck()}
                        panelImageJpegVisible={this.state.panelImageJpegVisible}
                        adicionarHistoricoAcoes={(acao, pedidoId) => this.AdicionarHistoricoAcoes(acao, pedidoId)}
                    />

                </Sidebar>


                <Sidebar
                    header="Compartilhar Link do Portal"
                    blockScroll={true}
                    position="bottom"
                    visible={this.state.visibleDialog}
                    modal={false}
                    onHide={() => this.setState({ visibleDialog: false })}
                    style={{ zIndex: "999", border: "none", height: "200px" }}
                >

                    <div className="tituloSlideForm">
                        <i className="pi pi-share-alt"></i> <strong>Compartilhar Link do Portal</strong>
                    </div>

                    <br></br>

                    <div style={{
                        display: "grid",
                        gridTemplateRows: "auto auto auto",
                        rowGap: "10px",
                        width: "100%",
                        position: "fixed",
                        left: "0",
                        bottom: "0",
                        padding: "20px 10px 10px 10px",
                        backgroundColor: "rgb(52, 51, 67)",
                        boxShadow: "0 0 10px 2px #ccc",
                    }}>


                        <div>

                            <div className=" ">

                                {
                                    this.tipoCompartilhamento.map((tipo) => {
                                        return (
                                            <div key={tipo.key} className="p-field-radiobutton" style={{ float: 'left', marginRight: '20px' }}>
                                                <RadioButton inputId={tipo.key} name="tipo" value={tipo} onChange={(e) => this.setState({ selectedCompartilhamento: e.value })} checked={this.state.selectedCompartilhamento.key === tipo.key} />
                                                <label htmlFor={tipo.key}>{tipo.name}</label>
                                            </div>
                                        )
                                    })
                                }

                            </div>

                            <br />
                            <br />
                            <InputMask type="tel" style={{ width: '100%', display: this.state.selectedCompartilhamento.key === 0 ? 'block' : 'none' }} id="celular" mask="(99)99999-9999" value={this.state.celCompartilhar} placeholder="(99)99999-9999" onChange={(e) => this.setState({ celCompartilhar: e.value })}></InputMask>
                            <InputText style={{ width: '100%', display: this.state.selectedCompartilhamento.key === 1 ? 'block' : 'none' }} name="email" placeholder="Informe o email" value={this.state.emailCompartilhar} onChange={(e) => { this.setState({ emailCompartilhar: e.target.value }) }} />
                        </div>

                        <div>
                            <label>Prazo de validade do link:</label>
                            <br />
                            <Dropdown
                                style={{ borderColor: '#e3ebf6' }}
                                options={listPrazo}
                                placeholder="Selecionar prazo"
                                value={this.state.prazoValue}
                                onChange={(e) => { this.setState({ prazoValue: e.value }) }}
                            />
                        </div>

                        <div
                            style={{
                                textAlign: "right",
                                borderTop: "solid 1px #ccc",
                                marginTop: "10px",
                                paddingTop: "10px"
                            }}>
                            <Button label="Compartilhar" className="p-button-info" onClick={e => { { this.handleCompartilharLinkPortal(); } }} style={{ marginRight: "10px" }} />
                            <Button label="Cancelar" className="p-button-text" onClick={e => this.setState({ visibleDialog: false })} />
                        </div>

                    </div>
                </Sidebar>

                <Sidebar visible={this.state.visibleDialogComentario}
                    fullScreen={true}
                    blockScroll={true}
                    modal={false}
                    showCloseIcon={true}
                    style={{ zIndex: "999", border: "none" }}
                    onHide={() => this.setState({ visibleDialogComentario: false })}>

                    <div className="tituloSlideForm">
                        <i className="pi pi-comment"></i> <strong>Parecer Médico</strong>
                    </div>

                    <br></br>

                    <div className="card" style={{ padding: "0px", height: "70vw", overflow: "auto", borderBottom: "solid 1px #ccc" }}>
                        <DataTable value={this.state.listaParecer} header="Histórico" className="p-datatable-gridlines">
                            <Column field="DataCadastro" header="Data"></Column>
                            <Column field="Texto" header="Descrição"></Column>
                            <Column field="Prioridade" header="Prioridade" style={{ textAlign: "center" }}></Column>
                        </DataTable>
                    </div>

                    <div style={{
                        display: "grid",
                        gridTemplateRows: "auto auto auto",
                        rowGap: "10px",
                        width: "100%",
                        position: "fixed",
                        left: "0",
                        bottom: "0",
                        padding: "20px 10px 10px 10px",
                        backgroundColor: "rgb(52, 51, 67)",
                        boxShadow: "0 0 10px 2px #ccc",
                    }}>

                        <div>
                            <label className="textWhite">Parecer: </label>
                            <InputTextarea
                                placeholder="Descreva o parecer médico aqui..."
                                value={this.state.parecerTexto}
                                onChange={(e) => this.setState({ parecerTexto: e.target.value })}
                                autoResize={true}
                                style={{ width: "100%", height: "100px" }}
                            />
                        </div>

                        <div>
                            <label className="textWhite">Prioridade: </label>
                            <Dropdown
                                value={this.state.parecerPrioridade}
                                options={prioridadeSelectItems}
                                onChange={(e) => { this.setState({ parecerPrioridade: e.value }) }}
                            />
                        </div>

                        <div
                            style={{
                                textAlign: "right",
                                borderTop: "solid 1px #ccc",
                                marginTop: "10px",
                                paddingTop: "10px"
                            }}>
                            <Button label="Salvar" onClick={e => { { this.handleSalvarParecer(); } }} style={{ marginRight: "10px" }} />
                            <Button label="Cancelar" className="p-button-text" onClick={e => this.setState({ visibleDialogComentario: false })} />
                        </div>

                    </div>

                </Sidebar>

                <ComponentsAppSplash visible={this.state.isLoading} />

                <div className="footer">© 2025 Tzion MyResult 2025.001.02.13</div>
            </div>

        );
    }
}

//Barra de progresso de Download
function updateProgress(oEvent) {
    clearInterval(pgrBarCont);
    if (oEvent.lengthComputable) {
        var percentComplete = oEvent.loaded / oEvent.total;
        percentComplete = (percentComplete * 100) + '%';
        let elProgresBar = document.getElementById("pgrBar");
        elProgresBar.setAttribute("style", "display:block; width:" + percentComplete);
    }
}
function transferComplete(evt) {
    clearInterval(pgrBarCont);
    viewPgr("none");
}
function transferFailed(evt) {
    clearInterval(pgrBarCont);
    viewPgr("none");
    alert("Um erro ocorreu durante o download do arquivo.");
}
function viewPgr(value) {
    let elProgresBar = document.getElementById("pgrBar");
    elProgresBar.setAttribute("style", "display:" + value + ";");
}
function viewPgrContinuous() {
    cntPgr++;
    if (cntPgr == 101) { cntPgr = 0; }
    let percentComplete = cntPgr + '%';
    let elProgresBar = document.getElementById("pgrBar");
    elProgresBar.setAttribute("style", "display:block; width:" + percentComplete);
}
//Fim barra de progresso de Download

export default ScreensHomeForm;